module.exports = __webpack_public_path__ + "static/media/Charlene Portante.c034c313.png";